export var RcThumbnailSizes = {
    small: 20,
    large: 36,
};
